import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import useStateRef from 'react-usestateref';

const MobileNavMenu = ({rule,index}) => {
    const attributes = rule?.ContentRuleZone?.[0]?.attributes;
 
    const childRules = rule?.ContentRuleZone?.[0]?.contents?.ContentFolderZone?.[0]?.childRules;
    console.log("childRules",childRules)
    const [selectedMenuItem, setSelectedMenuItem, selectedMenuItemRef] = useStateRef();
    const handleMenuItemClick = (menuItem) => {
        setSelectedMenuItem(menuItem);
        if (selectedMenuItemRef.current) {
            document.getElementById(`submenu-catagory${index}`).classList.remove('d-block');
            document.getElementById(`submenu-catagory${index}`).classList.add('d-none');
            document.getElementById(`submenu-title-catagory${index}`).classList.remove('d-none');
            document.getElementById(`submenu-title-catagory${index}`).classList.add('d-block');
        }
    };
    const handleSubmenuTitleClick = (e) => {
        const panelsStayOpenCollapse = e.currentTarget.getAttribute('parentId');
        console.log("panelsStayOpenCollapse",panelsStayOpenCollapse);
        if (selectedMenuItemRef.current) {
            document.getElementById(`submenu-catagory${index}`).classList.remove('d-none');
            document.getElementById(`submenu-catagory${index}`).classList.add('d-block');
            document.getElementById(panelsStayOpenCollapse).classList.add('show');
            document.getElementById(`submenu-title-catagory${index}`).classList.remove('d-block');
            document.getElementById(`submenu-title-catagory${index}`).classList.add('d-none');
        }
    };
    return (<>
    
    <div className="accordion-item d-block" id={`submenu-catagory${index}`}>
            <span className="accordion-header shop-padding" id={`panelsStayOpen-heading${index}`}>
                <button className="accordion-button color-catagory weight-shop collapsed text-uppercase" type="button" data-bs-toggle="collapse" data-bs-target={`#panelsStayOpen-collapse${index}`} aria-expanded="false" aria-controls={`panelsStayOpen-collapse${index}`}>
                    {attributes?.navSubText ?? ""}
                </button>
            </span>
            <div id={`panelsStayOpen-collapse${index}`} className="accordion-collapse collapse" aria-labelledby={`panelsStayOpen-heading${index}`} data-bs-parent="#catagory-collapse">
                         {childRules && childRules.map((rule, index) =>  {
                                 const menu = rule?.ContentRuleZone?.[0];
                                // console.log("menu",menu)
                                 return( <Fragment key={index}>
                                        {menu && menu.subMenus &&  menu.subMenus.length > 0 ?
                                            <div onClick={() => handleMenuItemClick(menu)} className='text-decoration-none sub-catagory-list-items '>
                                                <div className="accordion-body icon-arw border-top">
                                                    {menu.attributes.displayName ?? ""}
                                                    <span className='chervron-right-arw'>
                                                        <i className="bi bi-chevron-right d-block d-lg-none"></i>
                                                    </span>
                                                </div>
                                            </div>:
                                             <Link className='text-decoration-none sub-catagory-list-items ' to={menu?.attributes?.link ?? ""}>
                                             <div className="accordion-body icon-arw border-top">
                                              {menu?.attributes?.displayName ?? ""}
                                                 <span className='chervron-right-arw'>
                                                     <i className="bi bi-chevron-right d-block d-lg-none"></i>
                                                 </span>
                                             </div>
                                     </Link>}
                                    </Fragment>) })}
                {/* {rule?.ContentRuleZone?.[0]?.tabs && rule.ContentRuleZone[0].tabs.map((tab, index) =>  (
                        <Link className='text-decoration-none sub-catagory-list-items ' to={tab.attributes.link ?? ""}>
                            <div className="accordion-body icon-arw border-top">
                                {tab.attributes.displayName ?? ""}
                                <span className='chervron-right-arw'>
                                    <i className="bi bi-chevron-right d-block d-lg-none"></i>
                                </span>
                            </div>
                        </Link>
                ))} */}
            </div>
        </div>
         <li className="row c-nav-menu-l1 c-show-nav-l1 gx-0 d-none" id={`submenu-title-catagory${index}`}>
         <div className="c-nav-menu-l1-label cb-mobile-padding-nav" parentId ={`panelsStayOpen-collapse${index}`} onClick={handleSubmenuTitleClick} >
             <i className="bi bi-chevron-left d-lg-none"></i>
             { selectedMenuItem?.attributes?.displayName ?? ""}
             <i className="bi bi-chevron-right d-lg-none float-end"></i>
         </div>
         <div className="c-nav-menu-l cb-mobile-padding-nav-li">
             <div className="row">
                 <div className="col-12 col-lg-7">
                     <ul className="row list-unstyled sub-title-menu" >
                         {selectedMenuItem && selectedMenuItem.subMenus && (
                             selectedMenuItem.subMenus.map((subMenu, index) => {
                                 console.log('menu---of submenu--title', subMenu)
                                 return (
                                     <li className='sub-title-menu-list'>
                                         <Link to={subMenu.link ?? ""} className='sub-mune-list-sm'>{subMenu.displayName ? subMenu.displayName : ""} <i className="bi bi-chevron-right d-block d-lg-none"></i>
                                         </Link>
                                         </li>
                                 )
                             })

                         )}

                     </ul>
                 </div>
             </div>
         </div>
     </li></>
    )
}

export default MobileNavMenu